import { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useLayoutContext } from '@/layouts/LayoutContext';

const DownloadProgramContext = createContext();

export function DownloadProgramProvider({
  portalId,
  formUrl,
  programUrl,
  trainingName,
  modalDescription,
  modalTitle,
  testimonial,
  children,
}) {
  const [showDownloadProgramModal, setShowDownloadProgramModal] = useState(false);

  const { setLayoutContext } = useLayoutContext();

  const onShowModal = useCallback(() => {
    setLayoutContext({ modalIsOpen: true });
    setShowDownloadProgramModal(true);
  }, [setLayoutContext]);

  const onHideModal = useCallback(() => {
    setLayoutContext({ modalIsOpen: false });
    setShowDownloadProgramModal(false);
  }, [setLayoutContext]);

  const contextValue = {
    portalId,
    formUrl,
    programUrl,
    trainingName,
    modalDescription,
    modalTitle,
    testimonial,
    showDownloadProgramModal,
    onShowModal,
    onHideModal,
  };

  return (
    <DownloadProgramContext.Provider value={contextValue}>
      {children}
    </DownloadProgramContext.Provider>
  );
}

DownloadProgramProvider.defaultProps = {
  modalDescription: 'Proporciónenos sus datos para descargar el programa oficial del entrenamiento más completo para hispanohablantes.',
  modalTitle: 'Descarga tu programa de entrenamiento',
  testimonial: null,
};

DownloadProgramProvider.propTypes = {
  portalId: PropTypes.string.isRequired,
  formUrl: PropTypes.string.isRequired,
  programUrl: PropTypes.string.isRequired,
  trainingName: PropTypes.string.isRequired,
  modalDescription: PropTypes.string,
  modalTitle: PropTypes.string,
  testimonial: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export function DownloadProgramConsumer({
  children,
}) {
  return (
    <DownloadProgramContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('DownloadProgramConsumer must be used within a DownloadProgram.Provider')
        }
        return children(context);
      }}
    </DownloadProgramContext.Consumer>
  );
}

DownloadProgramConsumer.propTypes = {
  children: PropTypes.func.isRequired,
};

export function useDownloadProgram() {
  const context = useContext(DownloadProgramContext);

  if (context === undefined) {
    throw new Error('useDownloadProgram must be used within a DownloadProgram.Provider')
  }

  return context;
}
